import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from './messages';
import style from './order-templates.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const handleDeliveryNotificationClick = createSelector(
  (onDeliveryNotificationSelected) => onDeliveryNotificationSelected,
  (_, deliveryEmailTemplate) => deliveryEmailTemplate,
  (onDeliveryNotificationSelected, deliveryEmailTemplate) => () => onDeliveryNotificationSelected(deliveryEmailTemplate),
);

const DeliveryNotificationSelector = ({ selected, onDeliveryNotificationSelected, deliveryTemplates = emptyArray }) => {
  return (
    <div className={classnames(style['select-container'], 'select-container')}>
      <label className={style['select-label']}>
        <FormattedMessage {...messages.deliveryNotificationLabel} />
      </label>
      <DropdownMenu className={style['select-dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler theme='white'>
          {selected && selected.name}
          {!selected && <FormattedMessage {...messages.deliveryNotificationDefault} />}
        </DropdownMenuToggler>
        {deliveryTemplates.map((deliveryNotification) => (
          <DropdownMenuItem
            key={deliveryNotification.name}
            className='dropdown-menu-item'
            onClick={handleDeliveryNotificationClick(onDeliveryNotificationSelected, deliveryNotification)}
            selected={selected && deliveryNotification.name === selected.name}
          >
            {deliveryNotification.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

DeliveryNotificationSelector.propTypes = {
  selected: PropTypes.object.isRequired,
  onDeliveryNotificationSelected: PropTypes.func.isRequired,
  deliveryTemplates: PropTypes.array,
};

export default DeliveryNotificationSelector;
